import { render, staticRenderFns } from "./LmNoNotifyIcon.vue?vue&type=template&id=b5449b5a"
import script from "./LmNoNotifyIcon.vue?vue&type=script&lang=js"
export * from "./LmNoNotifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports